"use client"
import { cn } from '@/lib/utils'
import ChooseMode from "./ChooseMode";
// import UploadBtn from "./UploadBtn";
import VoiceBtn from "./VoiceBtn";
import { useLogin, useUserInfo } from "@/hooks/useUser";
import { useModal as useLoginModal } from "../modal/Provdier";
import { IModel } from "@/types";
import { useCallback, useState } from 'react'
import { useModel } from "@/hooks/useChat";
import { AI_ROLE_TYPE } from "@/constants";
import { useCookies } from 'react-cookie';
import { useVoice } from "@/hooks/useVoice";



export default function ChatInput({ modelList, data }: { modelList: IModel[], data: any }) {
  const [userInfo] = useUserInfo()
  const [selected] = useModel();

  const { setIsLoginOpen } = useLoginModal()

  // const taxtMap = {
  //   'publish': '请你作为“文心出版社”的编辑，分析这3年的投稿内容和现有的投稿栏目，帮我规划一个2026年的投稿栏目和收稿要求的优化和规划方案。',
  //   'aloud': '请你给我讲解一下朗诵与表达能力等级测试是怎么进行级别划分的？测评的内容有哪些？测评申报条件是什么？',
  //   'default': '请你作为一位历史老师，将工业革命这堂课的学习，进行一个AI赋能的创意教学场景设计，要求有趣味性，可以引起学生在课堂上学习的兴趣。',
  //   'xingmo': '在中学作文教学中，学生常出现“无话可写”或“内容空洞”的问题，教师可以采取哪些有效策略来帮助学生积累素材并提升表达能力？'
  // }

  // let text = taxtMap?.[data.id as keyof typeof taxtMap] || taxtMap['default']

  const [question, setQuestion] = useState<string>(userInfo?.id ? '' : data.dialogueExampleDetailVO.dialogueExample)
  function handleInput(e: React.ChangeEvent<HTMLTextAreaElement>) {
    setQuestion(e.target.value)
  }

  const [isThink, setIsThink] = useState<boolean>(false)

  const [, setChatCookie] = useCookies(['question', 'modelId', 'isThink']);

  // 语音识别完成后, 将文本放入输入框
  const handleVoiceDone = useCallback((text: string) => {
    setQuestion((prev) => (prev ? `${prev}${text}` : text))
  }, [])
  const { status: voiceStatus, toggleRecord } = useVoice(handleVoiceDone)

  // 点击语音按钮: 未登录弹出登录框, 已登录开始/结束录音
  function handleVoiceClick() {
    if (!userInfo?.id) {
      return setIsLoginOpen(true)
    }
    toggleRecord()
  }

  function handleSubmit() {
    if ((['aloud', 'xingmo'].includes(data.id) && !userInfo?.id) || !data?.dialogueExampleDetailVO?.id) {
      return setIsLoginOpen(true)
    }

    if (!userInfo?.id) {
      window.open('/chat/chat-view?viewId=' + data.dialogueExampleDetailVO.id, '_blank')
    } else {
      setChatCookie('question', question)
      setChatCookie('modelId', selected?.id?.toString() || '')
      setChatCookie('isThink', isThink)
      window.open('/chat', '_blank')
    }
  }



  return (
    <div className="w-full  bg-white shadow-[0_4px_20px_0_rgba(0,0,0,0.1)] rounded-2xl flex flex-col justify-between">
      {/* 这里展示上传完成的文件 */}

      <textarea className="w-full text-base/7 px-5 py-4.5 outline-none resize-none" placeholder="请输入您的问题" onInput={handleInput} value={question} disabled={!userInfo?.id} />

      <div className="flex items-center justify-between px-4 pb-3">
        <div>
          {selected?.id === AI_ROLE_TYPE.DEEPSEEKV3 && (
            <div
              onClick={() => setIsThink(!isThink)}
              className={cn(
                'flex items-center justify-center text-[#303133] h-8 text-sm px-2.5 rounded-full bg-white shadow-[0_1px_3px_0_rgba(0,0,0,0.1)] cursor-pointer border border-white',
                isThink ? 'border-[#131921]' : ''
              )}
            >
              <span className="font_family icon-Arrow_Forward2 text-2xl! text-[#303133] mr-1"></span>
              <span className='text-[#303133] text-[15px]'>深度思考</span>
            </div>
          )}
        </div>

        <div className="flex items-center justify-center gap-x-2">
          <ChooseMode data={modelList} selectedId={AI_ROLE_TYPE.DEEPSEEKV3} />
          {/* <UploadBtn /> */}
          <VoiceBtn status={voiceStatus} onClick={handleVoiceClick} />
          {
            (userInfo?.id || data.id === 'aloud' || data.id === 'xingmo') ? (
              <div onClick={handleSubmit} className='flex items-center justify-center text-[#303133] h-10 text-sm w-10 rounded-full bg-[#131921] shadow-[0_1px_3px_0_rgba(0,0,0,0.1)] cursor-pointer'>
                <span className="font_family icon-Arrow_Right text-2xl! text-white"></span>
              </div>
            ) : (
              <div
                onClick={handleSubmit}
                className='flex items-center justify-center text-[#303133] h-10 text-sm px-2.5 pr-4 rounded-full bg-[#131921] shadow-[0_1px_3px_0_rgba(0,0,0,0.1)] cursor-pointer'>
                <span className="font_family icon-Arrow_Right text-2xl! text-white"></span>
                <span className='text-white text-[15px]'>演示</span>
              </div>
            )
          }
        </div>
      </div>
    </div>
  )
}
